import React, {useState,forwardRef, useImperativeHandle, useEffect } from 'react';
import 'devextreme-react/text-area';
import ScrollView from 'devextreme-react/scroll-view';
import StatesService from '../../../utils/states';
import CountryService from '../../../utils/country';
import Form, {Item, RequiredRule,Label} from 'devextreme-react/form';
import { useHistory } from 'react-router-dom';
import DataSource from 'devextreme/data/data_source';
import notify from 'devextreme/ui/notify';
import OrderApi from '../../../api/order';
import ProductApi from '../../../api/product';
import sessions from '../../../sessions';
import {LoadPanel} from 'devextreme-react/load-panel';

const NewOrder  = forwardRef((props, ref) => {
    var  isClick= props.isClick; 
    const [countryValue, setCountryValue] = useState();
    const [showUsAddress, setShowUsAddress] = useState(false);
    const [isloadPanelVisible, setIsloadPanelVisible] = useState(false); 
    const [orderNo, setOrderNo] = useState();
    const position = { of: '#order-form' };
    const history = useHistory();

    const userId = sessions.getSession("user")?.id;
    const auth = sessions.getSession("user")?.accessToken;
    const now = new Date();

    useEffect(()=>{
        (async()=>{
            await OrderApi.getOrderNo(userId,auth).then(result => {
                setOrderNo(result.data.data);
            });
            setCountryValue('US');
          })()
    },[isClick,auth,userId]);

    const country = new DataSource({
        store: {
            type: 'array',
            data: CountryService,
            key: 'iso2'
        },
        pageSize: 10,
        paginate: true
    });
    const CountryOnChange = ({value}) => {
        setCountryValue(value);
    }

    const state = new DataSource({
        store: {
            data: StatesService,
            type: 'array',
            key: 'name'
        },
        filter: [
            "country_code", "=", countryValue
        ],
        pageSize: 10,
        paginate: true
    });

    const order = {
        "userId": userId,
        "name": "",
        "company": "",
        "addressVerified":false,
        "addressLine1": "",
        "addressLine2": "",
        "addressLine3": "",
        "city": "",
        "state": "",
        "zipCode": "",
        "country": countryValue,
        "phone": "",
        "email": "",
        "store": "Manual Orders",
        "orderNo": orderNo,
        "orderDate": now,
        "paidDate": now,
        "shippingPaid": 0,
        "taxPaid": 0,
        "totalPaid": 0,
        "currency": 'USD',
        "status": 'awaiting-shipment',
        "sku":[]
    }

    const [orderData, setOrderData] = useState(order);
    const [SKU, setSKU ] = useState([]);
    const checkBoxOnChange = ({value}) => {
        setShowUsAddress(value);
    }

    const saveOnClick = (e) =>{
        const res = e.validationGroup.validate(); 
        //console.log(res);
        handleSubmit(e);
    }

    const handleSubmit = async(e) => {
        e.event.preventDefault();
        setIsloadPanelVisible(true);
        try{
            if(SKU?.length>0){
                for(var i=0 ; i<SKU.length; i++){
                    // eslint-disable-next-line no-loop-func
                    await ProductApi.insertProduct({userId:userId,sku:SKU[i].sku,name:SKU[i].name},auth).then(response =>{
                        //console.log("productId",response.data.id);
                        orderData.sku.push({
                            product_id: response.data.id,
                            sku:SKU[i].sku,
                            name:SKU[i].name,
                            quantity: SKU[i].quantity,
                            price: SKU[i].price,
                        });
                    }).catch((err) => console.log(err));
                }
            }
    
            await OrderApi.insertManualOrder(orderData,auth).then(res => {
                setIsloadPanelVisible(false);
                notify("order data inserted succesfully", "success", 500);
                e.validationGroup.reset();  
                history.replace(`/orders/awaiting-shipment/manual-orders`);
            })
            .catch((err) => {
                console.log(err);
                if(err.message.includes("403"))
                    notify("Please Refresh The Page", "error", 500);
                else
                    notify("Error", "error", 500);
                setIsloadPanelVisible(false);
            });
        }catch(err){
            setIsloadPanelVisible(false);
        }
    }

    const gridDataOnIserted = (e) =>{
        console.log(e.data);
        setSKU(e.data);
    }

    useImperativeHandle(ref, (e) => ({saveOnClick}));

    return (
        <React.Fragment>
             <ScrollView>
                <form id="order-form" onSubmit={handleSubmit}>
                    <Form formData={orderData}
                        validationGroup='group'
                        labelLocation={'top'}>
                        <Item itemType="group" caption="Recipient Information" colSpan={2} colCount={3}>
                            <Item
                                editorType={'dxTextBox'}
                                dataField={'name'}
                                editorOptions={{
                                showClearButton: true
                            }}>
                                <RequiredRule message="name is required"/>
                            </Item>
                            <Item
                                editorType={'dxTextBox'}
                                dataField={'company'}
                                editorOptions={{
                                showClearButton: true
                            }}/>

                            <Item
                                editorType={'dxCheckBox'}
                                dataField={'show US Address'}
                                label={{
                                location:'left'
                            }}
                                editorOptions={{
                                showClearButton: true,
                                onValueChanged: checkBoxOnChange
                            }}/>
                            <Item
                                dataField="pasteUSAddress"
                                colSpan={3}
                                editorType="dxTextArea"
                                visible={showUsAddress}
                                editorOptions={{
                                height: 90
                            }}><Label text="Paste US Address"/></Item>
                            <Item
                                editorType={'dxSelectBox'}
                                dataField="country"
                                editorOptions={{
                                dataSource: country,
                                searchEnabled: true,
                                displayExpr: 'name',
                                valueExpr: 'iso2',
                                defaultValue: countryValue,
                                value: countryValue,
                                onValueChanged: CountryOnChange
                            }}>
                                <RequiredRule message="country is required"/>
                            </Item>
                            <Item
                                dataField="state"
                                editorType="dxSelectBox"
                                editorOptions={{
                                dataSource: state,
                                searchEnabled: true,
                                displayExpr: 'name',
                                valueExpr: 'name'
                            }}>
                                <RequiredRule message="state is required"/>
                            </Item>
                            <Item
                                editorType={'dxTextBox'}
                                dataField="city"
                                editorOptions={{
                                showClearButton: true
                            }}>
                                <RequiredRule message="city is required"/>
                            </Item>
                            <Item
                                editorType={'dxTextBox'}
                                helpText={"house/flat no, building name, street name/number"}
                                dataField="addressLine1"
                                editorOptions={{
                                showClearButton: true
                            }}>
                                <RequiredRule message="main address is required"/>
                            </Item>
                            <Item
                                editorType={'dxTextBox'}
                                dataField="addressLine2"
                                helpText={"Block no. , Area Name"}
                                editorOptions={{
                                showClearButton: true
                            }}/>
                            <Item
                                editorType={'dxTextBox'}
                                dataField="addressLine3"
                                helpText={"district"}
                                editorOptions={{
                                showClearButton: true
                            }}/>
                            <Item
                                editorType={'dxTextBox'}
                                dataField="zipCode"
                                editorOptions={{
                                showClearButton: true
                            }}>
                                <RequiredRule message="zip code is required"/>
                            </Item>
                            <Item
                                editorType={'dxTextBox'}
                                dataField="phone"
                                helpText="Example: 0111-111-1111"
                                editorOptions={{
                                showClearButton: true
                            }}/>
                            <Item
                                editorType={'dxTextBox'}
                                dataField={'email'}
                                editorOptions={{
                                showClearButton: true
                            }}/>
                        </Item>
                        <Item
                            itemType="group"
                            caption="Order Summary Information"
                            colSpan={2}
                            colCount={3}>
                            <Item
                                colSpan={3}
                                editorType={'dxTextBox'}
                                dataField="store"
                                editorOptions={{
                                readOnly: true,
                                width: '33%',
                                showClearButton: true
                            }}/>
                            <Item
                                editorType={'dxTextBox'}
                                dataField="orderNo"
                                editorOptions={{
                                    readOnly: true,
                                    value:orderNo
                            }}>
                                <RequiredRule message="order no is required"/>
                            </Item>
                            <Item
                                editorType={'dxDateBox'}
                                dataField="orderDate"
                                editorOptions={{
                                useMaskBehavior: true,
                                type: "date",
                                displayFormat: "shortdate"
                            }}/>
                            <Item
                                editorType={'dxDateBox'}
                                dataField="paidDate"
                                editorOptions={{
                                useMaskBehavior: true,
                                type: "date",
                                displayFormat: "shortdate"
                            }}/>
                            <Item
                                editorType={'dxNumberBox'}
                                dataField="shippingPaid"
                                editorOptions={{
                                format: "$ #,##0.##;($ #,##0.##)"
                            }}/>
                            <Item
                                editorType={'dxNumberBox'}
                                dataField="taxPaid"
                                editorOptions={{
                                format: "$ #,##0.##;($ #,##0.##)"
                            }}/>
                            <Item
                                editorType={'dxNumberBox'}
                                dataField="totalPaid"
                                editorOptions={{
                                format: "$ #,##0.##;($ #,##0.##)"
                            }}/>
                        </Item>

                        <Item editorType="dxDataGrid" 
                        editorOptions={{
                            dataSource:SKU,
                            columns:[
                                {
                                    dataField: "sku",
                                    datatype:"string"
                                },
                                {
                                    dataField: "name",
                                    datatype:"string"
                                },
                                {
                                    dataField: "quantity",
                                    datatype:"numeric",
                                    defaultValue: 1
                                },
                                {
                                    dataField: "price",
                                    caption: "price ($)",
                                    alignment:"right",
                                    datatype:"numeric"
                                }
                            ],
                            onRowInserted: {gridDataOnIserted},
                            editing:{
                                mode:'row',
                                allowAdding:true,
                                allowUpdating:true,
                                allowDeleting:true,
                                confirmDelete:false
                            }
                        }}
                        />
                    </Form>
                </form>
                <LoadPanel
                position={position}
                onHiding={!isloadPanelVisible}
                visible={isloadPanelVisible}
                showIndicator={true}
                shading={false}
                showPane={false}
                closeOnOutsideClick={false}/>
            </ScrollView>
        </React.Fragment>
    );
})

export default NewOrder;